export default "__VITE_ASSET__3jJcHWTdo$1m7MCPQMnJBw__"